"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();

import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_PRIMARY_FONT,
  UI_STYLE_YELLOW_COLOR_BUTTON,
  UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
} from "../../../../lib/constants"

const CustomButton = styled(Button)(() => ({
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
  backgroundColor: UI_STYLE_YELLOW_COLOR_BUTTON,
  boxShadow: "none",
  display: "flex",
  justifyContent: "center",
  padding: "0 20px",
  height: "77px",
  width: "308px",
  filter: "none",
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "19px",
  textTransform: "unset",
  textAlign: "center",
  letterSpacing: "0.54px",
  borderRadius: "10px",
  "@media only screen and (min-width: 900px)": {
    fontSize: "18px",
  },
  "&:hover": {
    backgroundColor: UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
  },
}))

type SectionButtonType = "GENERAL_QUESTIONS" | "GROUP_LEADER_QUESTIONS"

interface SectionButtonProps {
  type: SectionButtonType
}

export default function SectionButton({ type }: SectionButtonProps) {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id)
    if (el) {
      const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset
      const yOffset = -80
      window.scrollTo({
        top: yCoordinate + yOffset,
        behavior: "smooth",
      })
    }
  }

  switch (type) {
    case "GENERAL_QUESTIONS":
      return (
        <CustomButton onClick={() => scrollToSection("general-faq-header")}>
          General FAQ
        </CustomButton>
      )
    case "GROUP_LEADER_QUESTIONS":
      return (
        <CustomButton onClick={() => scrollToSection("group-leader-faq-header")}>
          Group Leader FAQ
        </CustomButton>
      )
    default:
      return null
  }
}
